export { Storage, SessionStorage } from './src/storage-proxy';
